module.exports = __webpack_public_path__ + "static/media/Screenshot 2019-04-11 at 23.10.04@2x.5b728cef.png";